<!-- statistics -->
<div class="section section-statistics bg-half-grey">
  <div class="container-fluid">

    <div class="container-photo">

      <div class="row">

        <div class="col-12 col-lg-4">

          <div class="counter text-center">
            <div class="counter-value">{{feed.statisticsObject.numberOfJobPostings}}</div>
            <div class="counter-description">{{'jobs &amp; internships' | translate}}</div>
          </div>

        </div>

        <div class="col-12 col-lg-4">

          <div class="counter text-center">
            <div class="counter-value">{{feed.statisticsObject.numberOfStudents}}</div>
            <div class="counter-description">{{'active members' | translate}}</div>
          </div>

        </div>

        <div class="col-12 col-lg-4">

          <div class="counter text-center">
            <div class="counter-value">{{feed.statisticsObject.numberOfCompanies}}</div>
            <div class="counter-description">{{'companies' | translate}}</div>
          </div>

        </div>

      </div>

    </div>

  </div>
</div>
